import "./contact.css";
import { useState } from "react";
import * as emailService from "services/email-service.js";
import React from "react";
import Header from "components/header/header";
import redSplash from "./assets/red-splash.png";
import orangeSlice from "./assets/orange-slice.png";
import blueLeaf from "./assets/blue-leaf.png";
import { Slide, ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Contact = () => {
  const [inputs, setInputs] = useState({
    fname: "",
    lname: "",
    email: "",
    message: "",
  });

  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };
  const toastSettings = {
    isLoading: false,
    autoClose: 1000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
  };

  const submitForm = async () => {
    const init = true;
    console.log(inputs);
    if (
      inputs.fname.trim() !== "" &&
      inputs.lname.trim() !== "" &&
      inputs.email.trim() !== "" &&
      inputs.message.trim() !== ""
    ) {
      const toastMsg = toast.loading("sending email", {});
      await emailService
        .sendEmail(inputs.fname, inputs.lname, inputs.email, inputs.message)
        .then((res) => {
          console.log(res);
          if (res.data.status === 200) {
            toast.update(toastMsg, {
              ...toastSettings,
              render: "email sent!",
              type: "success",
            });
            document.getElementById("contact-form").reset();
          } else {
            toast.update(toastMsg, {
              ...toastSettings,
              render: (
                <div>
                  something went wrong <br /> please try again.
                </div>
              ),
              type: "error",
            });
          }
        });
    } else {
      toast("please fill out all the fields!", {
        ...toastSettings,
        type: "error",
      });
    }
  };

  return (
    <div>
      <ToastContainer position="bottom-right" transition={Slide} />
      <Header />
      <div className="contact-header">
        <div className="contact-header-shader"></div>
        <div className="main-header">HIT US UP</div>
        <img alt="" className="red-splash" src={redSplash} />
        <img alt="" className="orange-slice" src={orangeSlice} />
      </div>
      <div className="form-wrapper text-start mx-auto wrapper">
        <div className="mb-5">
          <p className="description-text">
            We're available for birthday parties, weddings, chess club
            tournaments...really anything.
          </p>
        </div>
        <form id="contact-form">
          <div className="d-md-flex gap-4 mb-4">
            <div className="name-field">
              <label for="fname" class="form-label">
                First name
              </label>
              <input
                className="form-control"
                id="fname"
                type="text"
                name="fname"
                placeholder="jane"
                onChange={handleChange}
              />
            </div>
            <div className="name-field">
              <label for="lname" class="form-label">
                Last name
              </label>
              <input
                className="form-control"
                type="text"
                id="lname"
                name="lname"
                placeholder="doe"
                onChange={handleChange}
              />
            </div>
          </div>
          <div className="mb-4">
            <label for="email" class="form-label">
              Email
            </label>
            <input
              className="form-control"
              id="email"
              type="email"
              name="email"
              placeholder="janedoe@email.com"
              onChange={handleChange}
            />
          </div>
          <div className="mb-5">
            <label for="message" class="form-label">
              Message
            </label>
            <textarea
              className="form-control"
              name="message"
              id="message"
              placeholder="We got an awesome opportunity..."
              cols="20"
              rows="10"
              onChange={handleChange}
            />
          </div>
          <div className="d-flex justify-content-end mb-5">
            <primary-button
              className="btn btn-primary"
              type="button"
              onClick={() => {
                submitForm();
              }}
            >
              Submit
            </primary-button>
          </div>
        </form>
        <img alt="" className="blue-leaf" src={blueLeaf} />
        <br />
      </div>
    </div>
  );
};

export default Contact;
